<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
      <span v-if="iconShown" v-btooltip :tooltip="tooltipValue">
        <i class="fas fa-info-circle"></i>
      </span>
    </label>

    <MultiSelect
      :id="id"
      ref="field"
      v-model="inputValue"
      :class="[
        {
          'p-invalid': typeof validate !== 'undefined' && validate.$error,
        },
        inputClass,
      ]"
      :disabled="disabled"
      :placeholder="placeholder"
      :autofocus="autofocus"
      :options="options"
      :optionLabel="optionLabel"
      :optionValue="optionValue"
      :optionDisabled="optionDisabled"
      :showClear="showClear"
      :filter="filter"
      :filterPlaceholder="filterPlaceholder"
      :display="display"
      :appendTo="appendTo"
      @change="$emit('change', $event)"
      @input="$emit('input', $event)"
    />

    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>

<script>
import MultiSelect from "primevue/multiselect";

export default {
  components: {
    MultiSelect,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    //Dropdown label
    label: {
      type: String,
    },
    tooltipValue: {
      type: String,
    },
    // Dropdown reactive value
    value: {
      type: [String, Object, Array],
      default: "",
    },

    // Dropdown placeholder
    placeholder: {
      type: String,
      default: "Please Select",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },

    // Dropdown disabled state
    disabled: {
      type: Boolean,
      default: false,
    },
    // Dropdown autofocus state
    autofocus: {
      type: Boolean,
      default: false,
    },
    //Dropdown options
    options: {
      type: Array,
      default: null,
    },

    //Dropdown option label
    optionLabel: {
      type: String,
      default: null,
    },
    //Dropdown option value
    optionValue: {
      type: String,
      default: null,
    },
    //Dropdown option diabled
    optionDisabled: {
      type: String,
      default: null,
    },
    //Dropdown show clear icon
    showClear: {
      type: Boolean,
      default: false,
    },
    //Dropdown show filter
    filter: {
      type: Boolean,
      default: false,
    },
    appendTo: {
      type: String,
      default: "",
    },
    //Dropdown filter placeholder
    filterPlaceholder: {
      type: String,
      default: null,
    },
    //Dropdown display (chip or comma)
    display: {
      type: String,
      default: "comma",
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },

    // Multi select control

    labelShown: {
      type: Boolean,
      default: false,
    },
    iconShown: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
